import { LoadingSpinner, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Contact, ContactRequest } from 'src/graphql/generated/graphql'
import { useState } from 'src/hooks'
import styles from './actSetupEditRecipient.module.scss'
import ContactSearch from '../ContactSearch/ContactSearch'
import ActSetupSubActionHeader from '../ActSetupPanel/ActSetupSubActionHeader'
import {
  useDigitalCardOrderCreate,
  useDigitalCardRecipientCreate,
} from 'src/react_query'

export type SetupActions =
  | 'EditRecipient'
  | 'EditSender'
  | 'EditPaymentMethod'
  | 'Main'

type ActSetupEditRecipientProps = {
  onBack: (recipientName?: string) => void
  digitalCardPk?: string
  hasActOrder: boolean
}

const ActSetupEditRecipient: React.FC<ActSetupEditRecipientProps> = props => {
  const { onBack, digitalCardPk, hasActOrder } = props

  const [recipientName, setRecipientName] = useState('')
  const [contact, setContact] = useState<Contact | undefined>(undefined)
  const [contactRequest, setContactRequest] = useState<
    ContactRequest | undefined
  >(undefined)
  const createDigitalCardRecipientMutation = useDigitalCardRecipientCreate()
  const digitalCardOrderCreateMutation = useDigitalCardOrderCreate()
  const [isLoading, setIsLoading] = useState(false)

  const createActOrder = async (
    selContact?: Contact,
    selContactReq?: ContactRequest,
  ) => {
    const isRecipientSelected = !!recipientName || !!selContact
    if (isRecipientSelected) {
      if (digitalCardPk) {
        setIsLoading(true)
        await createDigitalCardRecipientMutation.mutateAsync({
          digitalCardPk: digitalCardPk,
          ...(selContact
            ? { contactUuid: selContact.id }
            : {
                firstName: selContactReq
                  ? selContactReq.firstName
                  : recipientName,
              }),
        })

        if (!hasActOrder) {
          await digitalCardOrderCreateMutation.mutateAsync({
            digitalCardPk: digitalCardPk,
          })
        }
        setIsLoading(false)

        onBack(recipientName)
      }
    }
  }

  const handleContactSelect = (selectedContact?: Contact) => {
    setContact(selectedContact)
    setContactRequest(undefined)
    createActOrder(selectedContact)
  }

  const handleContactRequestSelect = (
    selectedContactRequest: ContactRequest,
  ) => {
    setContact(undefined)
    setContactRequest(selectedContactRequest)
    createActOrder(undefined, selectedContactRequest)
  }

  const handleContactRequestCreate = () => {
    setContact(undefined)
    setContactRequest(undefined)
    createActOrder()
  }

  const handleContactSearchRecipientChanges = (value: string) => {
    setRecipientName(value)
    if (contact) {
      setContact(undefined)
    }
    if (contactRequest) {
      setContactRequest(undefined)
    }
  }

  return (
    <div className={styles.wrapper}>
      <ActSetupSubActionHeader title="To:" onBack={onBack} />
      <div className={styles.setup}>
        <div className={styles.row}>
          <ContactSearch
            onContactSelect={handleContactSelect}
            onContactRequestSelect={handleContactRequestSelect}
            onContactRequestCreate={handleContactRequestCreate}
            onChange={handleContactSearchRecipientChanges}
            currentlySelectedContactId={contact?.id}
            currentlySelectedContactRequestId={contactRequest?.id}
          />
        </div>
      </div>
      {isLoading && (
        <div className={styles.loading}>
          <div>
            <LoadingSpinner size="large" />
          </div>
          <Text type="body" content="Adding Recipient..." alignment="center" />
        </div>
      )}
    </div>
  )
}

export default ActSetupEditRecipient
